import ChevronDown from "../../../../../../shared/svg/chevron-down";

interface CollapsibleSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const CollapsibleSection = ({
  title,
  isExpanded,
  onToggle,
  children,
}: CollapsibleSectionProps) => {
  return (
    <div
      className="collapsible-section flex flex-col border-b border-[#e5e7eb] bg-white"
      style={{
        flex: isExpanded ? "1 1 auto" : "0 0 auto",
      }}
    >
      <div
        className="flex flex-shrink-0 cursor-pointer items-center justify-between px-4 py-3 transition-colors duration-200 hover:bg-[#f9fafb]"
        onClick={onToggle}
      >
        <span className="text-base font-semibold leading-[1.5rem] text-[#374151]">
          {title}
        </span>
        <ChevronDown
          stroke="#374151"
          height={16}
          width={16}
          rotate={isExpanded ? 180 : 0}
        />
      </div>
      {isExpanded && (
        <div
          className="collapsible-section__content overflow-y-auto"
          style={{
            minHeight: 0,
          }}
        >
          <div className="rounded border border-[#e5e7eb] bg-white">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
